import React, { useState, useEffect } from "react";
import { FaMicrophone, FaMicrophoneSlash } from "react-icons/fa";
import * as webRTCHandler from "../../utils/webRTCHandler";

const MicButton = () => {
  const [isMicMuted, setIsMicMuted] = useState(true);

  useEffect(() => {
    // Check initial mic state
    const stream = webRTCHandler.getLocalStream();
    if (stream && stream.getAudioTracks().length > 0) {
      setIsMicMuted(!stream.getAudioTracks()[0].enabled);
    }
  }, []);

  const handleMicButtonPressed = () => {
    const newMuteState = !isMicMuted;
    webRTCHandler.toggleMic(newMuteState);
    setIsMicMuted(newMuteState);
  };

  return (
    <div className="video_button_container tooltip" onClick={handleMicButtonPressed} data-tooltip={isMicMuted ? "Unmute" : "Mute"}>
      <span className={`video_button_icon ${isMicMuted ? 'muted' : ''}`}>
        {isMicMuted ? (
          <FaMicrophoneSlash size={20} />
        ) : (
          <FaMicrophone size={20} />
        )}
      </span>
      <span className="video_button_label">{isMicMuted ? "Unmute" : "Mute"}</span>
    </div>
  );
};

export default MicButton;
